module.exports = __webpack_public_path__ + "static/media/nutrition.c52bc7a5.svg";